import { createIcon } from '@chakra-ui/icons'

const WOFF2Icon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#7AB2D1"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        WOFF2
      </text>
      <path
        fill="#E1E4EB"
        d="M-5288.4 4782v-2.7h10.5v26.5h-2.3c-.6 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h7c.6 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2h-2.3v-26.5h10.5v2.7c0 .6.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-3.9c0-.6-.5-1.2-1.2-1.2h-25.7c-.6 0-1.2.5-1.2 1.2v3.9c0 .6.5 1.2 1.2 1.2.6-.1 1.1-.6 1.1-1.2z"
      />
      <path
        fill="#E1E4EB"
        d="M-5254.5 4790.9h-13.2c-.6 0-1.2.5-1.2 1.2v2.7c0 .6.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-1.6h4.3v12.5h-.8c-.6 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h3.9c.6 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2h-.8v-12.5h4.3v1.2c0 .6.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-2.3c-.1-.7-.7-1.2-1.3-1.2z"
      />
    </g>
  ),
})

export default WOFF2Icon
